import { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import OOI from './ooi'
import { LifeCycle, WixCodeSdkHandlersProviderSym } from '@wix/thunderbolt-symbols'
import { OOISsrManagerSymbol, ReactLoaderForOOISymbol } from './symbols'
import { ooiComponentsRegistrar } from './ooiComponentsRegistrar'
import { ComponentsRegistrarSymbol } from '@wix/thunderbolt-components-loader'
import { WarmupDataEnricherSymbol } from 'feature-warmup-data'
import OOIPostSsrPropsEnricher from './ssr/ooiPostSsrPropsEnricher'
import OOISsrManager from './ssr/ooiSsrManager'

export const page: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageWillMountHandler, WixCodeSdkHandlersProviderSym).to(OOI)
}

export const site: ContainerModuleLoader = (bind) => {
	if (process.env.browser) {
		bind(ReactLoaderForOOISymbol).to(require('./componentsLoaderClient').default)
		bind(LifeCycle.AppWillMountHandler, LifeCycle.AppDidMountHandler).to(OOIPostSsrPropsEnricher)
	} else {
		bind(ReactLoaderForOOISymbol).to(require('./componentsLoaderSSR').default)
		bind(OOISsrManagerSymbol, WarmupDataEnricherSymbol).to(OOISsrManager)
	}
	bind(ComponentsRegistrarSymbol).to(ooiComponentsRegistrar)
}

export * from './types'
export * from './symbols'
